import {
	promoIconSX,
	separatorSx,
	typoSX,
} from '@/components/blocks/PromotionCard/styles/PromoIconStyles';
import {
	PRODUCT_CARD_PROMO_ICONS_IMG_URL,
	PROMOTION_TYPES,
} from '@/data/constants/promoIconConstants';
import { useLocalization } from '@/data/Localization';
import { setClassName } from '@/data/utils/usePromoIcons/promoLists';
import { Box, CardMedia, Divider, Stack, Typography } from '@mui/material';
import { CDN_BASE_URL } from 'shared/custom/constants/commonConstants';

export const CEPromo = () => {
	const { TimeLimited, UniqueChange, SpecialPurchase } = useLocalization('PromoIconsTxt');
	const ICON_URL = `${CDN_BASE_URL}/${PRODUCT_CARD_PROMO_ICONS_IMG_URL.PROMOICON_CE}`;
	return (
		<Box>
			<Divider sx={separatorSx} />
			<Stack id={PROMOTION_TYPES.PROMOICON_CE} direction="row">
				<CardMedia
					image={ICON_URL}
					sx={promoIconSX.ce}
					title={SpecialPurchase.t()}
					component="img"
					className={setClassName(PROMOTION_TYPES.PROMOICON_CE)}
				/>
				<Box>
					<Typography variant="body1" sx={typoSX.firstRow}>
						{TimeLimited.t()}
					</Typography>
					<Typography variant="body1" sx={typoSX.secondRow}>
						{UniqueChange.t()}
					</Typography>
				</Box>
			</Stack>
		</Box>
	);
};
